import React, { useMemo } from 'react';
import { faRefresh, faAdd } from '@fortawesome/free-solid-svg-icons';
import ActionToolbar from '../common/ActionToolbar';
import { useTranslation } from 'react-i18next';

/**
 * WarehouseActions
 * Action toolbar for warehouses page: search, refresh, add
 */
const WarehouseActions = ({
  searchValue = '',
  onSearchChange,
  onAddWarehouse,
  onRefresh,
  loading = false,
  refreshLoading = false,
  showSearch = true,
}) => {
  const { t } = useTranslation();
  const actions = useMemo(() => {
    return [
      {
        key: 'refresh-warehouses',
        label: t('warehouses.actions.buttons.refresh'),
        icon: faRefresh,
        onClick: onRefresh,
        disabled: refreshLoading || loading,
        variant: 'ghost',
        showLabelBreakpoint: 'sm',
        spinner: refreshLoading,
      },
      {
        key: 'add-warehouse',
        label: t('warehouses.actions.buttons.add'),
        icon: faAdd,
        onClick: onAddWarehouse,
        disabled: loading || refreshLoading,
        variant: 'primary',
        showLabelBreakpoint: 'sm',
      },
    ];
  }, [onAddWarehouse, onRefresh, loading, refreshLoading, t]);

  return (
    <ActionToolbar
      showSearch={showSearch}
      searchValue={searchValue}
      onSearchChange={onSearchChange}
      searchPlaceholder={t('warehouses.actions.searchPlaceholder')}
      actions={actions}
    />
  );
};

export default WarehouseActions;
